import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import SalesReportsContent from '../SalesReportsContent';
import {
    setFromDate,
    setToDate,
    setSelectedBranch,
    fetchSalesReportData
} from '../../../store/slices/salesReportsSlice';

const SalesReports = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';
    const storedBranchName = localStorage.getItem('branchname') || 'Current Branch';

    useEffect(() => {
        const today = new Date();
        dispatch(setFromDate(today));
        dispatch(setToDate(today));
        dispatch(setSelectedBranch({ branch_id: storedBranchId, branch_name: storedBranchName }));
        dispatch(fetchSalesReportData({
            fromDate: today,
            toDate: today,
            branchId: storedBranchId
        }));
    }, [dispatch, storedBranchId, storedBranchName]);

    return <SalesReportsContent isManagerView />;
};

export default SalesReports;
